import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

import CustomButton from '../../../../../../../../../lib/designSystem/Button';

interface SubjectOptionsDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (
    option: 'common' | 'details' | 'perOperation',
    commonSubject?: string,
  ) => void;
  currentSubject?: string;
}

const SubjectOptionsDialog: React.FC<SubjectOptionsDialogProps> = ({
  open,
  onClose,
  onConfirm,
  currentSubject = '',
}) => {
  const [selectedOption, setSelectedOption] = useState<
    'common' | 'details' | 'perOperation'
  >('common');
  const [commonSubject, setCommonSubject] = useState(currentSubject);

  const handleConfirm = () => {
    onConfirm(selectedOption, commonSubject);
    onClose();
  };

  const handleClose = () => {
    setSelectedOption('common');
    setCommonSubject(currentSubject);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" component="div">
          Opciones de Asunto para Facturas
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <FormControl component="fieldset">
            <FormLabel component="legend">
              <Typography variant="subtitle1" sx={{ mb: 2 }}>
                Selecciona cómo deseas configurar el asunto de las facturas:
              </Typography>
            </FormLabel>

            <RadioGroup
              value={selectedOption}
              onChange={(e) =>
                setSelectedOption(
                  e.target.value as 'common' | 'details' | 'perOperation',
                )
              }
            >
              <FormControlLabel
                value="common"
                control={<Radio />}
                label={
                  <Box>
                    <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                      Texto común
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Usar el mismo asunto para todas las facturas
                    </Typography>
                  </Box>
                }
              />

              <FormControlLabel
                value="details"
                control={<Radio />}
                label={
                  <Box>
                    <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                      Agregar detalles
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Configurar asuntos individuales para cada detalle de
                      factura
                    </Typography>
                  </Box>
                }
              />

              <FormControlLabel
                value="perOperation"
                control={<Radio />}
                label={
                  <Box>
                    <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                      Detalle por operación
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Crear un detalle separado para cada operación
                    </Typography>
                  </Box>
                }
              />
            </RadioGroup>
          </FormControl>

          {selectedOption === 'common' && (
            <Box sx={{ mt: 3 }}>
              <TextField
                fullWidth
                label="Asunto común para todas las facturas"
                value={commonSubject}
                onChange={(e) => setCommonSubject(e.target.value)}
                placeholder="Ej: Servicios Factoring"
                variant="outlined"
                multiline
                rows={2}
              />
            </Box>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <CustomButton color="secondary" onClick={handleClose}>
          Cancelar
        </CustomButton>
        <CustomButton
          color="primary"
          onClick={handleConfirm}
          disabled={selectedOption === 'common' && !commonSubject.trim()}
        >
          Confirmar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default SubjectOptionsDialog;
